import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const SnakePath = () => {
  const pathRef = useRef(null);

  useEffect(() => {
    const path = pathRef.current;
    if (!path) return;
    const length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = length;
    const tween = gsap.to(path, {
      strokeDashoffset: 0,
      ease: "none",
      scrollTrigger: { trigger: document.body, start: "top top", end: "bottom bottom", scrub: 1.2 },
    });
    return () => { tween.scrollTrigger?.kill(); tween.kill(); };
  }, []);

  return (
    <div className="absolute inset-0 pointer-events-none z-[1] overflow-hidden" aria-hidden="true">
      <svg className="w-full h-full" viewBox="0 0 100 1000" preserveAspectRatio="none" fill="none">
        <path
          ref={pathRef}
          d="M 50 0
             C 50 30, 85 45, 85 70 C 85 95, 15 105, 15 135 C 15 165, 88 175, 88 205
             C 88 235, 10 250, 12 285 C 14 320, 90 330, 88 365 C 86 400, 12 410, 14 445
             C 16 480, 86 490, 84 525 C 82 560, 15 575, 18 610 C 21 645, 84 655, 82 690
             C 80 725, 14 740, 16 775 C 18 810, 85 820, 83 855 C 81 890, 20 905, 22 935
             C 24 965, 60 975, 50 1000"
          stroke="#3E5C3A"
          strokeOpacity="0.35"
          strokeWidth="0.35"
          vectorEffect="non-scaling-stroke"
          style={{ strokeWidth: "1.5px" }}
        />
      </svg>
    </div>
  );
};
